import Dataset from "./Dataset";

export default class Pathways extends Dataset {
  type = "feature";
}
